module.exports = __webpack_public_path__ + "img/Elven_Axe_01.b516158a.png";